import {Injectable} from '@angular/core';
import {Subject} from "rxjs";
import {breadcrumbDropdownEnum} from "../../utils/constant/common.const";
import { BrowserPopupBlockInfoDiagComponent } from '../../components/browser-popup-block-info-diag/browser-popup-block-info-diag.component';
import { DialogService } from "primeng/dynamicdialog";
import { ProfileComponent } from '../../components/profile/profile.component';
import { AppraiserUtilsService } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private triggerGetGuideGridDataList = new Subject<number>();
  private triggerGetPageList = new Subject<number>();

  triggerGetGuideGridDataList$ = this.triggerGetGuideGridDataList.asObservable();

  triggerGetPageList$ = this.triggerGetPageList.asObservable();

  constructor(public dialogService: DialogService, private _utilsService: AppraiserUtilsService){}
  emitGetGuideGridDataList(dropType: number,productId: number,) {
    if(dropType === breadcrumbDropdownEnum.ProductType) {
      // dropType === 1 is for product type dropdown
      this.triggerGetGuideGridDataList.next(productId);
    } else  if (dropType === breadcrumbDropdownEnum.Page) {
      // dropType === 2 is for Page dropdown
      this.triggerGetPageList.next(productId);
    }
  }

  checkAndShowBrowserPopupBlockMsg(url: string,isSameWindow = false): void {
    // Detecting Browser level popup is blocked or not
    if (isSameWindow) window.open(url, "_self");
    else {
      const tempWindow = window.open(undefined, "", "width=10,height=10");
      if (tempWindow) {
        tempWindow.close();
        const formWindow = window.open(url, "_blank");
        if (!formWindow) this.showBlockMessage();
      } else this.showBlockMessage();
    }    
  }

  showBlockMessage(): void {
    this.dialogService.open(BrowserPopupBlockInfoDiagComponent, {
      modal: true,
      header: 'Popups Are Blocked',
      width: '33vw',
      maximizable: true,
      draggable: true,
      breakpoints: { '960px': '40vw', '640px': '90vw' }
    })
  }

  async showProfileDetialsDiag(): Promise<void> {
    const data = await this._utilsService.getUserProfile();
    if (data && Object.keys(data).length) {
      this.dialogService.open(ProfileComponent, {
        header: 'Profile Details',
        width: '30vw',
        modal: true,
        breakpoints: {
          '1340px': '50vw',
          '960px': '75vw',
          '640px': '90vw'
        },
        contentStyle: { 'max-height': '500px', overflow: 'auto' },
        baseZIndex: 10000,
      });
    }
    // this._utilsService.profileDetails$.subscribe((_) => {
      
    // })
    // if (LocalStorageUtils.getAccessToken(USER_ID)) {
    //       this._utilsService.getProfileDetailsById(LocalStorageUtils.getAccessToken(USER_ID) as string).subscribe({
    //         next: (response): void => {
    //           this.dialogService.open(ProfileComponent, {
    //             header: 'Profile Details',
    //             width: '30vw',
    //             modal: true,
    //             breakpoints: {
    //               '1340px': '50vw',
    //               '960px': '75vw',
    //               '640px': '90vw'
    //             },
    //             contentStyle: { 'max-height': '500px', overflow: 'auto' },
    //             baseZIndex: 10000,
    //           });
    //           this.profileDetails = response.data;
    //         }
    //       })
    //     }
   
  }
}
